<template>
  <div class="location-filters">
    <div class="flex justify-between mb-4">
      <FormLabel class=" h-10 flex items-center font-semibold w-24 mr-2 shrink-0">
        Event Type
      </FormLabel>

      <SearchField
        id="location-filters__tags"
        ref="tagSelect"
        placeholder="Event type"
        :icon="SearchIcon"
        :options="tags"
        :model-value="form.eventType"
        error-messages-in-tooltip
        @change="$emit('eventTypeChange', $event)"
        @openChanged="$emit('eventTypeOpenChanged', $event)"
      />
    </div>

    <div class="flex justify-between">
      <FormLabel class="h-10 flex items-center font-semibold w-24 mr-2 shrink-0">
        Where
      </FormLabel>

      <LocationField
        id="location-filters__location"
        ref="locationSelect"
        placeholder="Location"
        :icon="PinIcon"
        :model-value="form.location"
        :clear-on-focus-value="NEAR_ME_LABEL"
        :country-code="countryCode"
        @change="$emit('locationChange', $event)"
        @openChanged="$emit('locationOpenChanged', $event)"
      />
    </div>
  </div>
</template>

<script>
import SearchIcon from '@tagvenue/icons/24/line/general/search-md.svg';
import PinIcon from '@tagvenue/icons/24/line/maps-travel/marker-pin-01.svg';

import FormLabel from '@/components/Ui/Forms/FormLabel.vue';
import LocationField from '@/components/Ui/Forms/LocationField.vue';
import SearchField from '@/components/Ui/Forms/SearchField.vue';
import { NEAR_ME_LABEL } from '@/constants/location';

export default {
  name: 'LocationFilters',
  emits: ['locationChange', 'eventTypeChange', 'locationOpenChanged', 'eventTypeOpenChanged'],
  components: { SearchField, FormLabel, LocationField },
  props: {
    form: {
      type: Object,
      required: true,
    },
    tags: {
      type: Array,
      required: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    countryCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      PinIcon,
      SearchIcon,
      NEAR_ME_LABEL,
    };
  },

  methods: {
    validate() {
      const { isValid: isTagValid } = this.$refs.tagSelect.validate();
      const locationSelectValid = this.$refs.locationSelect.valueMatchesModelValue();

      return {
        isValid: isTagValid && locationSelectValid,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@sass/design-system/variables" as ds-variables;

.location-filters :deep(input) {
  background-color: ds-variables.$grey-100;
  border-color: ds-variables.$grey-100;
}
</style>
